import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { ScrollArea } from "@/components/ui/scroll-area";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Loader2, Send, Send as SendIcon, Eye, FileText } from "lucide-react";
import { EmailBlockEditor } from "./EmailBlockEditor";
import { HeroImageField } from "./HeroImageField";

export const SendMailDialog = ({
  open,
  onOpenChange,
  group,
  contactsCount,
  templates,
  selectedTemplate,
  onApplyTemplate,
  subject,
  setSubject,
  blocks,
  setBlocks,
  heroImage,
  setHeroImage,
  preheader,
  setPreheader,
  hasContent,
  onSubmit,
  sending,
  onSendTest,
  sendingTest,
  onPreview,
  loadingPreview,
}) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="max-w-2xl max-h-[92vh] flex flex-col" data-testid="send-mail-dialog">
      <DialogHeader>
        <DialogTitle>Rundmail gestalten &amp; senden</DialogTitle>
        <DialogDescription>
          An alle <strong>{contactsCount}</strong> Empfänger der Gruppe „{group?.name}".
          {group?.last_sent_at && (
            <span className="block mt-1 text-xs">
              Zuletzt gesendet: {new Date(group.last_sent_at).toLocaleString("de-DE", { dateStyle: "medium", timeStyle: "short" })}
              {group.last_sent_subject ? ` · „${group.last_sent_subject}"` : ""}
            </span>
          )}
        </DialogDescription>
      </DialogHeader>
      <form onSubmit={onSubmit} className="flex flex-col min-h-0 flex-1">
        <ScrollArea className="flex-1 min-h-0 pr-3 -mr-3">
          <div className="py-2 space-y-4">
            <div className="space-y-2">
              <Label htmlFor="send-template" className="flex items-center gap-1.5">
                <FileText className="w-3.5 h-3.5" /> Vorlage
              </Label>
              <Select value={selectedTemplate} onValueChange={onApplyTemplate}>
                <SelectTrigger id="send-template" data-testid="send-template-select">
                  <SelectValue placeholder="Vorlage wählen (optional)" />
                </SelectTrigger>
                <SelectContent>
                  {templates.map((t) => (
                    <SelectItem key={t.id} value={t.id} data-testid={`template-option-${t.id}`}>
                      {t.name}
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>
            <div className="space-y-2">
              <Label htmlFor="send-subject">Betreff *</Label>
              <Input id="send-subject" value={subject} onChange={(e) => setSubject(e.target.value)} required data-testid="send-subject-input" />
            </div>
            <div className="space-y-2">
              <Label htmlFor="send-preheader">Vorschauzeile</Label>
              <Input id="send-preheader" value={preheader || ""} onChange={(e) => setPreheader(e.target.value)} placeholder="Kurzer Vorschautext für das Postfach (optional)" data-testid="send-preheader-input" />
            </div>
            <HeroImageField value={heroImage} onChange={setHeroImage} />
            <div className="space-y-2">
              <Label>Inhalt</Label>
              <EmailBlockEditor blocks={blocks} onChange={setBlocks} />
            </div>
          </div>
        </ScrollArea>
        <DialogFooter className="gap-2 sm:gap-2 pt-3 border-t mt-2">
          <Button type="button" variant="outline" onClick={() => onOpenChange(false)}>Abbrechen</Button>
          <Button type="button" variant="secondary" onClick={onSendTest} disabled={sendingTest || !hasContent} data-testid="send-test-btn">
            {sendingTest ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : <SendIcon className="w-4 h-4 mr-2" />}
            Test an mich
          </Button>
          <Button type="button" variant="secondary" onClick={onPreview} disabled={loadingPreview || !hasContent} data-testid="send-preview-btn">
            {loadingPreview ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : <Eye className="w-4 h-4 mr-2" />}
            Vorschau
          </Button>
          <Button type="submit" disabled={sending || !hasContent} data-testid="send-confirm-btn">
            {sending ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : <Send className="w-4 h-4 mr-2" />}
            Senden
          </Button>
        </DialogFooter>
      </form>
    </DialogContent>
  </Dialog>
);
